import { render, staticRenderFns } from "./MealWeighingTable.vue?vue&type=template&id=118a7cef&scoped=true"
import script from "./MealWeighingTable.vue?vue&type=script&lang=js"
export * from "./MealWeighingTable.vue?vue&type=script&lang=js"
import style0 from "./MealWeighingTable.vue?vue&type=style&index=0&id=118a7cef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a7cef",
  null
  
)

export default component.exports